<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import ContactAPI from 'dashboard/api/contacts';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);

const deleteAllContacts = async () => {
  try {
    await ContactAPI.deleteAll();
    useAlert(t('CONTACTS_LAYOUT.DELETE_ALL_SUCCESS_MESSAGE'));
    emit('confirm');
  } catch (error) {
    useAlert(t('CONTACTS_LAYOUT.DELETE_ALL_ERROR_MESSAGE'));
  }
};

const handleDialogConfirm = async () => {
  await deleteAllContacts();
  dialogRef.value?.close();
};

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CONTACTS_LAYOUT.DELETE_ALL_CONFIRMATION_TITLE')"
    :description="t('CONTACTS_LAYOUT.DELETE_ALL_CONFIRMATION')"
    :confirm-button-label="t('CONTACTS_LAYOUT.DETAILS.DELETE_DIALOG.CONFIRM')"
    @confirm="handleDialogConfirm"
  />
</template>
